export enum ErrorImgType {
  PageNotFound = "pageNotFound",
  WarningSign = "warningSign",
}
